<div *ngIf="{labourOpData: $labourOpData | async,
    maintenanceTemplateError: vmService.getTemplateDetailError() | async,
    quoteLines: serviceLaneFacade.quoteLines$ | async,
    gmSltData: gmSltData$ | async} as data" fxLayout="row" fxLayoutAlign="start start">
  <div fxLayout="row" fxFlex class="content" fxLayoutAlign="start start">
    <div fxLayout="column" fxFlex [@flyOutIn]="dank">
      <div id="quotes" fxLayoutAlign="space-between start">
        <h2>Services</h2>
        <div fxLayout="row" fxLayoutAlign="end center" style="margin:4px">
          <div fxLayout="row">
            <span>Only Show Due</span>
            <mat-slide-toggle [disabled]="readOnly" color="primary" [checked]="true" (change)=sliderChanged($event)
              style="margin-left:8px;">
            </mat-slide-toggle>
          </div>
        </div>
      </div>

      <div *ngIf="data.maintenanceTemplateError == null; else noMaintenanceSchedule">
        <div style="margin:8px 8px 8px 8px;" fxLayoutAlign="space-between center">
          <span class="mat-subheading-2" style="font-weight:500;">Factory Required Services</span>
          <button mat-icon-button style="margin-right:4px;"
            (click)="toggleCollapse(factoryRequiredServices, factoryRequiredServicesUi)">
            <mat-icon>{{factoryRequiredServicesUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
            </mat-icon>
          </button>
        </div>

        <ng-container *ngIf="factoryRequiredServices; else loading">
          <div fxLayout="column"
            *ngFor="let menuItem of factoryRequiredServices | orderBy: ['frequencyMileage','dueDate','displayServiceGroup.name']"
            class="testing-concept" class="qcontainer"
            style="overflow:hidden;page-break-before:always;border-radius:8px;padding:24px 16px 16px 16px;background-color:#FFF;margin-bottom:12px;"
            data-cy='factory-required-services'>
            <div fxLayout="row" fxLayoutAlign="space-between start">
              <div fxLayout="column">
                <div fxLayoutAlign="start center">
                  <button mat-icon-button style="margin-right:4px;" (click)="menuItem.collapsed = !menuItem.collapsed">
                    <mat-icon>{{menuItem.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</mat-icon>
                  </button>
                  <h3 class="mat-body-2">
                    {{menuItem.displayServiceGroup.name}}</h3>
                </div>
                <h4 class="mat-body-1 secondary-text">Due {{menuItem.dueDate| date}} {{menuItem.dueBy}}
                  ({{menuItem.frequencyMileage}}{{mileageLabel}} or {{menuItem.frequencyMonths}} months) </h4>

                <div *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.displayServiceGroup)" fxLayout="row"
                  fxLayoutAlign="start center">
                  <div class="accepted-service"></div>
                  <span class="mat-caption secondary-text">Accepted on current transaction</span>
                </div>
                <div *ngIf="checkServiceGroupStatus('saved-declined', menuItem.displayServiceGroup)" fxLayout="row"
                  fxLayoutAlign="start center">
                  <div class="declined-service"></div>
                  <span class="mat-caption secondary-text">Declined on current transaction</span>
                </div>

              </div>
              <div *ngIf="data.labourOpData?.serviceGroupRates; else loadPricing">
                <h3 class="mat-body-1 secondary-text" *ngIf="menuItem.displayServiceGroup.useFlag !== 'M'">
                  {{getPrice(menuItem.displayServiceGroup,
                  data.labourOpData.serviceGroupRates) | currency}}</h3>
                <h3 class="mat-body-1 secondary-text" *ngIf="menuItem.displayServiceGroup.useFlag === 'M'">N/A</h3>
              </div>
              <ng-template #loadPricing>
                <h3 class="animated-background" style="height:20px;width:26px;margin:5px 0 5px 0;border-radius:4px;">
                </h3>
              </ng-template>
            </div>
            <ng-container *ngIf="!menuItem.collapsed">
              <ul *ngIf="data.labourOpData?.services;else loadingServices">
                <li *ngFor="let service of menuItem.displayServiceGroup.services" [@fadeInOut]
                  class="mat-body-1 secondary-text">{{data.labourOpData.services[service].name}}</li>
              </ul>
              <ng-template #loadingServices>
                <ul>
                  <li class="animated-background secondary-text"
                    style="height:14px;width:60%;margin:5px 0 5px 0;border-radius:4px;"></li>
                  <li class="animated-background secondary-text"
                    style="height:14px;width:40%;margin:5px 0 5px 0;border-radius:4px;"></li>
                </ul>
              </ng-template>
            </ng-container>
            <mat-divider style="margin:8px -16px 8px -16px"></mat-divider>
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <div>
                <button mat-icon-button
                  [disabled]="menuItem.serviceGroup.useFlag !== 'M' || checkServiceGroupStatus('saved-accepted', menuItem.displayServiceGroup) || checkServiceGroupStatus('saved-declined', menuItem.displayServiceGroup) || readOnly"
                  (click)="selectService(menuItem, data.labourOpData.serviceGroups, data.labourOpData.serviceGroupRates)">
                  <mat-icon>view_list</mat-icon>
                </button>
                <button mat-icon-button [disabled]="menuItem.displayServiceGroup.salesHint == null || readOnly"
                  (click)="viewSalesHint(menuItem.displayServiceGroup.salesHint)">
                  <mat-icon>help</mat-icon>
                </button>
              </div>

              <div
                *ngIf="!checkServiceGroupStatus('saved-accepted', menuItem.displayServiceGroup) && !checkServiceGroupStatus('saved-declined', menuItem.displayServiceGroup)">
                <ng-container>
                  <button mat-icon-button
                    [disabled]="readOnly || menuItem.displayServiceGroup.useFlag === 'M' || checkServiceGroupStatus('pending-accepted', menuItem.displayServiceGroup) "
                    (click)="addQuoteLineToServer(menuItem, data.labourOpData, data.gmSltData)">
                    <mat-icon>add_circle_outline</mat-icon>
                  </button>
                </ng-container>
                <ng-container *ngIf="!checkServiceGroupStatus('pending-accepted', menuItem.displayServiceGroup);">
                  <button mat-icon-button [disabled]="readOnly"
                    *ngIf="checkServiceGroupStatus('pending-declined', menuItem.displayServiceGroup); else removeButton"
                    (click)="removeDeclinedService(menuItem, data.quoteLines, data.gmSltData)" style="color:#C62828">
                    <mat-icon>remove_circle</mat-icon>
                  </button>
                  <ng-template #removeButton>
                    <button mat-icon-button
                      [disabled]="menuItem.displayServiceGroup.useFlag === 'M' || readOnly || menuItem.displayServiceGroup.workOrderLocationOpCode == null"
                      (click)="selectDeclinedReason(menuItem, declinedReasons, data.labourOpData, data.gmSltData)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </ng-template>
                </ng-container>

                <ng-container *ngIf="!checkServiceGroupStatus('pending-declined', menuItem.displayServiceGroup);">

                  <button mat-icon-button [disabled]="readOnly"
                    *ngIf="checkServiceGroupStatus('pending-accepted', menuItem.displayServiceGroup); else addButton"
                    (click)="removeAcceptedService(menuItem, data.quoteLines, data.gmSltData)" style="color:#2E7D32">
                    <mat-icon>remove_circle</mat-icon>
                  </button>
                  <ng-template #addButton>
                    <button mat-icon-button (click)="acceptService(menuItem, data.labourOpData, data.gmSltData)"
                      [disabled]="menuItem.displayServiceGroup.useFlag === 'M' || readOnly">
                      <mat-icon>check</mat-icon>
                    </button>
                  </ng-template>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>

        <div style="margin:8px 8px 8px 8px;" fxLayoutAlign="space-between center">
          <span class="mat-subheading-2" style="font-weight:500;">Factory Recommended Services</span>
          <button mat-icon-button style="margin-right:4px;"
            (click)="toggleCollapse(factoryRecommendedServices, factoryRecommendedServicesUi)">
            <mat-icon>{{factoryRecommendedServicesUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
            </mat-icon>
          </button>
        </div>

        <ng-container *ngIf="factoryRecommendedServices; else loading">
          <div fxLayout="column"
            *ngFor="let menuItem of factoryRecommendedServices | orderBy: ['frequencyMileage','dueDate','displayServiceGroup.name']"
            class="testing-concept" class="qcontainer"
            style="overflow:hidden;page-break-before:always;border-radius:8px;padding:24px 16px 16px 16px;background-color:#FFF;margin-bottom:12px;"
            data-cy='factory-recommended-services'>
            <div fxLayout="row" fxLayoutAlign="space-between start">
              <div fxLayout="column">
                <div fxLayoutAlign="start center">
                  <button mat-icon-button style="margin-right:4px;" (click)="menuItem.collapsed = !menuItem.collapsed">
                    <mat-icon>{{menuItem.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</mat-icon>
                  </button>
                  <h3 class="mat-body-2">{{menuItem.displayServiceGroup.name}}</h3>
                </div>
                <h4 class="mat-body-1 secondary-text">Due {{menuItem.dueDate| date}} {{menuItem.dueBy}}
                  ({{menuItem.frequencyMileage}}{{mileageLabel}} or {{menuItem.frequencyMonths}} months) </h4>
                <div *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.displayServiceGroup)" fxLayout="row"
                  fxLayoutAlign="start center">
                  <div class="accepted-service"></div>
                  <span class="mat-caption secondary-text">Accepted on current transaction</span>
                </div>
                <div *ngIf="checkServiceGroupStatus('saved-declined', menuItem.displayServiceGroup)" fxLayout="row"
                  fxLayoutAlign="start center">
                  <div class="declined-service"></div>
                  <span class="mat-caption secondary-text">Declined on current transaction</span>
                </div>

              </div>
              <div *ngIf="data.labourOpData?.serviceGroupRates; else loadPricing">
                <h3 class="mat-body-1 secondary-text" *ngIf="menuItem.displayServiceGroup.useFlag !== 'M'">
                  {{getPrice(menuItem.displayServiceGroup,
                  data.labourOpData.serviceGroupRates) | currency}}</h3>
                <h3 class="mat-body-1 secondary-text" *ngIf="menuItem.displayServiceGroup.useFlag === 'M'">N/A</h3>
              </div>
              <ng-template #loadPricing>
                <h3 class="animated-background" style="height:18px;width:26px;margin:5px 0 5px 0;border-radius:4px;">
                </h3>
              </ng-template>
            </div>
            <ng-container *ngIf="!menuItem.collapsed">
              <ul *ngIf="data.labourOpData?.services;else loadingServices">
                <li *ngFor="let service of menuItem.displayServiceGroup.services" [@fadeInOut]
                  class="mat-body-1 secondary-text">{{data.labourOpData.services[service].name}}</li>
              </ul>
            </ng-container>
            <ng-template #loadingServices>
              <ul>
                <li class="animated-background secondary-text"
                  style="height:14px;width:60%;margin:5px 0 5px 0;border-radius:4px;"></li>
                <li class="animated-background secondary-text"
                  style="height:14px;width:40%;margin:5px 0 5px 0;border-radius:4px;"></li>
              </ul>
            </ng-template>
            <mat-divider style="margin:8px -16px 8px -16px"></mat-divider>
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <div>
                <button mat-icon-button
                  [disabled]="menuItem.serviceGroup.useFlag !== 'M' || checkServiceGroupStatus('saved-accepted', menuItem.displayServiceGroup) || checkServiceGroupStatus('saved-declined', menuItem.displayServiceGroup) || readOnly"
                  (click)="selectService(menuItem, data.labourOpData.serviceGroups, data.labourOpData.serviceGroupRates)">
                  <mat-icon>view_list</mat-icon>
                </button>

                <button mat-icon-button [disabled]="menuItem.displayServiceGroup.salesHint == null || readOnly"
                  (click)="viewSalesHint(menuItem.displayServiceGroup.salesHint)">
                  <mat-icon>help</mat-icon>
                </button>
              </div>

              <div
                *ngIf="!checkServiceGroupStatus('saved-accepted', menuItem.displayServiceGroup) && !checkServiceGroupStatus('saved-declined', menuItem.displayServiceGroup)">
                <ng-container>
                  <button mat-icon-button
                    [disabled]="readOnly || menuItem.displayServiceGroup.useFlag === 'M' || checkServiceGroupStatus('pending-accepted', menuItem.displayServiceGroup) "
                    (click)="addQuoteLineToServer(menuItem, data.labourOpData, data.gmSltData)">
                    <mat-icon>add_circle_outline</mat-icon>
                  </button>
                </ng-container>
                <ng-container *ngIf="!checkServiceGroupStatus('pending-accepted', menuItem.displayServiceGroup);">
                  <button mat-icon-button [disabled]="readOnly"
                    *ngIf="checkServiceGroupStatus('pending-declined', menuItem.displayServiceGroup); else removeButton"
                    (click)="removeDeclinedService(menuItem, data.quoteLines, data.gmSltData)" style="color:#C62828">
                    <mat-icon>remove_circle</mat-icon>
                  </button>
                  <ng-template #removeButton>
                    <button mat-icon-button [disabled]="menuItem.displayServiceGroup.useFlag === 'M' || readOnly"
                      (click)="selectDeclinedReason(menuItem, declinedReasons, data.labourOpData, data.gmSltData)"
                      [disabled]="menuItem.displayServiceGroup.useFlag === 'M'
                      || !(data.labourOpData.serviceGroupRates[menuItem.displayServiceGroup.serviceGroupRateId] && data.labourOpData.serviceGroupRates[menuItem.displayServiceGroup.serviceGroupRateId].rate)
                      || menuItem.displayServiceGroup.workOrderLocationOpCode == null">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </ng-template>
                </ng-container>

                <ng-container *ngIf="!checkServiceGroupStatus('pending-declined', menuItem.displayServiceGroup);">
                  <button mat-icon-button [disabled]="readOnly || (disableRemoveServiceButton$ | async)"
                    *ngIf="checkServiceGroupStatus('pending-accepted', menuItem.displayServiceGroup); else addButton"
                    (click)="removeAcceptedService(menuItem, data.quoteLines, data.gmSltData)"
                    [ngClass]="{'green-color' : (disableRemoveServiceButton$ | async) === false}">
                    <mat-icon>remove_circle</mat-icon>
                  </button>
                  <ng-template #addButton>
                    <button mat-icon-button (click)="acceptService(menuItem, data.labourOpData, data.gmSltData)"
                      [disabled]="readOnly ||menuItem.displayServiceGroup.useFlag === 'M' || (disableAddServiceButton$ | async)">
                      <mat-icon>check</mat-icon>
                    </button>
                  </ng-template>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>

        <div style="margin:8px 8px 8px 8px;" fxLayoutAlign="space-between center">
          <span class="mat-subheading-2" style="font-weight:500;">Dealer Recommended Services</span>
          <button mat-icon-button style="margin-right:4px;"
            (click)="toggleCollapse(dealerRecommendedServices, dealerRecommendedServicesUi)">
            <mat-icon>{{dealerRecommendedServicesUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
            </mat-icon>
          </button>
        </div>
        <ng-container *ngIf="dealerRecommendedServices; else loading">
          <div fxLayout="column"
            *ngFor="let menuItem of dealerRecommendedServices | orderBy: ['frequencyMileage','dueDate','displayServiceGroup.name']"
            class="testing-concept" class="qcontainer"
            style="overflow:hidden;page-break-before:always;border-radius:8px;padding:24px 16px 16px 16px;background-color:#FFF;margin-bottom:12px;">
            <div fxLayout="row" fxLayoutAlign="space-between start">
              <div fxLayout="column">
                <div fxLayoutAlign="start center">
                  <button mat-icon-button style="margin-right:4px;" (click)="menuItem.collapsed = !menuItem.collapsed">
                    <mat-icon>{{menuItem.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</mat-icon>
                  </button>
                  <h3 class="mat-body-2">{{menuItem.displayServiceGroup.name}}</h3>
                </div>
                <h4 class="mat-body-1 secondary-text">Due {{menuItem.dueDate| date}} {{menuItem.dueBy}}
                  ({{menuItem.frequencyMileage}}{{mileageLabel}} or {{menuItem.frequencyMonths}} months) </h4>
                <div *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.displayServiceGroup)" fxLayout="row"
                  fxLayoutAlign="start center">
                  <div class="accepted-service"></div>
                  <span class="mat-caption secondary-text">Accepted on current transaction</span>
                </div>
                <div *ngIf="checkServiceGroupStatus('saved-declined', menuItem.displayServiceGroup)" fxLayout="row"
                  fxLayoutAlign="start center">
                  <div class="declined-service"></div>
                  <span class="mat-caption secondary-text">Declined on current transaction</span>
                </div>

              </div>
              <div *ngIf="data.labourOpData?.serviceGroupRates; else loadPricing">
                <h3 class="mat-body-1 secondary-text" *ngIf="menuItem.displayServiceGroup.useFlag !== 'M'">
                  {{getPrice(menuItem.displayServiceGroup,
                  data.labourOpData.serviceGroupRates) | currency}}</h3>
                <h3 class="mat-body-1 secondary-text" *ngIf="menuItem.displayServiceGroup.useFlag === 'M'">N/A</h3>
              </div>
              <ng-template #loadPricing>
                <h3 class="animated-background" style="height:18px;width:26px;margin:5px 0 5px 0;border-radius:4px;">
                </h3>
              </ng-template>
            </div>
            <ng-container *ngIf="!menuItem.collapsed">
              <ul *ngIf="data.labourOpData?.services;else loadingServices">
                <li *ngFor="let service of menuItem.displayServiceGroup.services" [@fadeInOut]
                  class="mat-body-1 secondary-text">{{data.labourOpData.services[service].name}}</li>
              </ul>
            </ng-container>
            <ng-template #loadingServices>
              <ul>
                <li class="animated-background secondary-text"
                  style="height:14px;width:60%;margin:5px 0 5px 0;border-radius:4px;"></li>
                <li class="animated-background secondary-text"
                  style="height:14px;width:40%;margin:5px 0 5px 0;border-radius:4px;"></li>
              </ul>
            </ng-template>
            <mat-divider style="margin:8px -16px 8px -16px"></mat-divider>
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <div>
                <button mat-icon-button
                  [disabled]="menuItem.serviceGroup.useFlag !== 'M' || checkServiceGroupStatus('saved-accepted', menuItem.displayServiceGroup) || checkServiceGroupStatus('saved-declined', menuItem.displayServiceGroup) || readOnly"
                  (click)="selectService(menuItem, data.labourOpData.serviceGroups, data.labourOpData.serviceGroupRates)">
                  <mat-icon>view_list</mat-icon>
                </button>
              </div>

              <div
                *ngIf="!checkServiceGroupStatus('saved-accepted', menuItem.displayServiceGroup) && !checkServiceGroupStatus('saved-declined', menuItem.displayServiceGroup)">
                <ng-container>
                  <button mat-icon-button
                    [disabled]="readOnly || menuItem.displayServiceGroup.useFlag === 'M' || checkServiceGroupStatus('pending-accepted', menuItem.displayServiceGroup) "
                    (click)="addQuoteLineToServer(menuItem, data.labourOpData, data.gmSltData)">
                    <mat-icon>add_circle_outline</mat-icon>
                  </button>
                </ng-container>
                <ng-container *ngIf="!checkServiceGroupStatus('pending-accepted', menuItem.displayServiceGroup);">
                  <button mat-icon-button [disabled]="readOnly"
                    *ngIf="checkServiceGroupStatus('pending-declined', menuItem.displayServiceGroup); else removeButton"
                    (click)="removeDeclinedService(menuItem, data.quoteLines, data.gmSltData)" style="color:#C62828">
                    <mat-icon>remove_circle</mat-icon>
                  </button>
                  <ng-template #removeButton>
                    <button mat-icon-button [disabled]="menuItem.displayServiceGroup.useFlag === 'M' || readOnly"
                      (click)="selectDeclinedReason(menuItem, declinedReasons, data.labourOpData, data.gmSltData)"
                      [disabled]="menuItem.displayServiceGroup.useFlag === 'M'
                      || !(data.labourOpData.serviceGroupRates[menuItem.displayServiceGroup.serviceGroupRateId] && data.labourOpData.serviceGroupRates[menuItem.displayServiceGroup.serviceGroupRateId].rate)
                      || menuItem.displayServiceGroup.workOrderLocationOpCode == null">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </ng-template>
                </ng-container>

                <ng-container *ngIf="!checkServiceGroupStatus('pending-declined', menuItem.displayServiceGroup);">
                  <button mat-icon-button [disabled]="readOnly"
                    *ngIf="checkServiceGroupStatus('pending-accepted', menuItem.displayServiceGroup); else addButton"
                    (click)="removeAcceptedService(menuItem, data.quoteLines, data.gmSltData)" style="color:#2E7D32">
                    <mat-icon>remove_circle</mat-icon>
                  </button>
                  <ng-template #addButton>
                    <button mat-icon-button (click)="acceptService(menuItem, data.labourOpData, data.gmSltData)"
                      [disabled]="readOnly || menuItem.displayServiceGroup.useFlag === 'M'">
                      <mat-icon>check</mat-icon>
                    </button>
                  </ng-template>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-template #loading>
          <div class="qcontainer"
            style="page-break-before:always;border-radius:8px;padding:24px 16px 16px 16px;background-color:#FFF;margin-bottom:12px;"
            *ngFor="let placeholder of [1,2,3,4]" data-cy='loading-services-container'>
            <div fxLayout="row" fxLayoutAlign="space-between start">
              <h3 class="animated-background" style="height:20px;width:40%;margin:5px 0 5px 0;border-radius:4px;"></h3>
              <h3 class="animated-background" style="height:18px;width:26px;margin:5px 0 5px 0;border-radius:4px;"></h3>
            </div>
            <h3 class="animated-background" style="height:20px;width:30%;margin:5px 0 5px 0;border-radius:4px;"></h3>
            <ul style="margin:20px 0 12px 0;">
              <li class="animated-background secondary-text"
                style="height:14px;width:60%;margin:5px 0 5px 0;border-radius:4px;"></li>
              <li class="animated-background secondary-text"
                style="height:14px;width:40%;margin:5px 0 5px 0;border-radius:4px;"></li>
            </ul>
            <mat-divider style="margin:8px -16px 8px -16px"></mat-divider>
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <div>
                <button mat-icon-button [disabled]="true">
                  <mat-icon>view_list</mat-icon>
                </button>
              </div>
              <div>
                <button mat-icon-button [disabled]="true">
                  <mat-icon>add_circle_outline</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </div>

      <ng-template #noMaintenanceSchedule>
        <div fxLayout="column" fxLayoutAlign="center center">
          <mat-icon style="height:96px;width:96px;" color="no-results-icon" svgIcon="maintenance"></mat-icon>
          <span class="mat-body-2">No maintenance schedule applied to this vehicle.</span>
        </div>
      </ng-template>
    </div>
  </div>
</div>